import { instance, GETREQUESTOPTIONS } from '../apiService';

// events fired by the client
export enum EVENT_KEYS {
    clickSuggestion = 'Suggestion Click',
    clickResult = 'Result Click',
    clickOpenIFU = 'Click Open IFU',
    clickViewDetails = 'Click View Details',
    activeSystemSelect = 'Active System Select',
    activeGeneratorSelect = 'Active Generator Select',
    activeLeadSelect = 'Active Lead Select',
    activeFindConditions = 'Active Find Conditions',
    activeOpenAttachment = 'Active Open Attachment',
    tooltipView = 'Tooltip View',
    clickCreatePolicy = 'Click Create Policy',
    clickCreateRoom = 'Click Create Room',
    clickCreateCpt = 'Click Create CPT',
    clickCreateGroup = 'Click Create Group',
    searchResults = 'Search Results',
    viewCptAnalytics = 'View CPT Analytics',
    wizardStep = 'Wizard Step',
    clickAddVariable = 'Click Add Variable',
    clickSetupVariables = 'Click Setup Variables',
    viewDepartmentVariables = 'View Department Variables',
    onboardingWizardOpen = 'Onboarding Wizard Open',
    onboardingWizardStep = 'Onboarding Wizard Step',
    onboardingWizardNext = 'Onboarding Wizard Next',
    onboardingWizardBack = 'Onboarding Wizard Back',
    onboardingWizardClose = 'Onboarding Wizard Close',
    onboardingWizardFinish = 'Onboarding Wizard Finish',
    onboardingHelpButtonClick = 'Onboarding Help Button Click',
    viewApprovedImplants = 'View Approved Implants',
    clickExport = 'Click Export',
    clickPrint = 'Click Print',
    clickCopy = 'Click Copy',
}

interface TrackedInfo {
    searchTerm?: string;
    implantModel?: string;
    manufacturer?: string;
    systemName?: string;
    generatorName?: string;
    leadName?: string;
    attachmentName?: string;
    combination?: string;
    tidioStatus?: string;
    implantId?: string;
    tooltipId?: string;
    suggestionType?:
        | 'implant'
        | 'manufacturer'
        | 'implantType'
        | 'protocol'
        | 'folder'
        | 'policy';
    value?: string;
    resultCount?: number;
    scenario?: string;
    step?: number;
    source?: 'auto' | 'help_button' | 'unknown';
    currentStep?: number;
    totalSteps?: number;
    stepIndex?: number;
    stepKey?: string;
    stepTitle?: string;
    fromStepIndex?: number;
    toStepIndex?: number;
    fromStepKey?: string;
    toStepKey?: string;
    reason?: 'dismissed' | 'completed';
    location?: 'homepage';
    wizardAvailable?: boolean;
    previewSource?: 'implant' | 'cpt' | 'policy';
}

export const trackClick = (eventType: EVENT_KEYS, info: TrackedInfo) => {
    instance.post(
        '/api/tracking/click',
        { eventType, info },
        GETREQUESTOPTIONS()
    );
};

export const trackLoad = (eventType: EVENT_KEYS, info: TrackedInfo) => {
    instance.post(
        '/api/tracking/load',
        { eventType, info },
        GETREQUESTOPTIONS()
    );
};
